import { clearPortoJourney } from "./portoJourney/portoJourneyState";

/** Azzera filtri mappa e riporta alla home pulita. */
export function performHomeReset(interMappa) {
  try {
    clearPortoJourney();
  } catch {
    /* noop */
  }
  try {
    interMappa?.resetInterMappa?.();
  } catch {
    /* noop */
  }
  if (typeof window !== "undefined") {
    window.history.replaceState(null, "", "/");
    window.scrollTo({ top: 0, behavior: "smooth" });
  }
}
